import viamadeinitaly from './viamadeinitaly';
import around from './around';

export default {
  viamadeinitaly,
  around
};
